import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useIntl } from "react-intl";
import {
  Skus,
  SkuContentRuleRequestExtended,
  ISkuContentRuleRequest,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import SkuRuleForm from "./SkuRuleForm";

type SkuRuleCreateFormProps = {
  onSkuRuleCreated: (id: string) => void;
  onCancel: () => void;
  sku: Skus;
  isMembershipGatedAccessEnabled: boolean;
};

const SkuRuleCreateForm = ({
  onSkuRuleCreated,
  onCancel,
  sku,
  isMembershipGatedAccessEnabled,
}: SkuRuleCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const onSubmit = async (values: ISkuContentRuleRequest) => {
    if (!sku.ownerOrganizationId) {
      return { [FORM_ERROR]: t({ id: "genericError" }) };
    }
    try {
      const response = await registerPromise(
        skuService.saveSkuContentRule(
          sku.id!,
          new SkuContentRuleRequestExtended({ ...values, organizationId: sku.ownerOrganizationId })
        )
      );
      onSkuRuleCreated(response.id);
    } catch (err) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <SkuRuleForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      sku={sku}
      isMembershipGatedAccessEnabled={isMembershipGatedAccessEnabled}
      title={t({ id: "createRuleTitle" })}
      submitLabel={t({ id: "createRuleButton" })}
    />
  );
};

export default SkuRuleCreateForm;
